import { isNil } from 'ramda';
import {
  addMonths,
  format,
  formatISO,
  isBefore,
  isAfter,
  isValid,
  parseISO,
  sub,
} from 'date-fns';

export const defaultFormat = 'dd-MM-yyyy';

export const nextMonth = () => {
  return addMonths(new Date(), 1);
};

export const tzUTC = (date, time = null) => {
  // 17/05/2020, 23:59:59, 00:00:01
  const [dd, mm, yyyy] = date.split('/'); // 2019-11-20
  const currentTime = new Date().toLocaleTimeString();

  if (time) {
    return new Date(`${mm}/${dd}/${yyyy} ${time}`).toISOString();
  }

  return new Date(`${mm}/${dd}/${yyyy} ${currentTime}`).toISOString();
};

export const formatDate = (date, dateFormat = null) => {
  const formattedDate = typeof date === 'string' ? parseISO(date) : date;

  return date ? format(formattedDate, dateFormat || defaultFormat) : '';
};

export const validateDate = date => {
  if (isNil(date) || date === '') {
    return false;
  }

  const [dd, mm, yyyy] = date.split('/'); // 2019-11-20

  return date.length < 10 ? false : isValid(new Date(`${yyyy}-${mm}-${dd}`));
};

export const startOfDay = date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);

export const getEarlierDate = (dateOne, dateTwo) => {
  return isAfter(parseISO(dateOne), parseISO(dateTwo)) ? dateTwo : dateOne;
};

export const buildDateRange = start => {
  let current = parseISO(start);
  const list = [];

  while (isBefore(current, new Date())) {
    list.push(formatDate(current, 'MM-yyyy'));
    current = addMonths(current, 1);
  }

  return list;
};

export const endOfDay = date =>
  new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59,
    999,
  );

export const isAfterToday = date => isAfter(date, new Date());
export const subDurationFromToday = duration => sub(new Date(), duration);
